<template>
  <div class="rail">
    <div ref="tvaScrollIndicator" id="tvaScrollIndicator"></div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.$refs.tvaScrollIndicator.style.width = this.perc
      ? this.perc + "%"
      : "0" + "%";
    window.addEventListener("scroll", () => {
      const scrollPos = window.scrollY;
      const winHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      const perc = (100 * scrollPos) / (docHeight - winHeight);
      this.perc = perc;
      if (this.$refs.tvaScrollIndicator) {
        this.$refs.tvaScrollIndicator.style.width = this.perc
          ? this.perc + "%"
          : "0" + "%";
      }
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
.rail {
  width: 100%;
  background: $eni-light-grey;
}
#tvaScrollIndicator {
  height: 1px;
  background-color: $eni-yellow;
  z-index: 999;
}
</style>